// TODO remove after implementing Stripe v3

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { StringModifierServiceProvider } from '@services/helpers/string-modifier-service/stringModifier.service';

@Injectable()
export class StripeDataProvider {
	constructor(
		private http: HttpClient,
		private stringModifierService: StringModifierServiceProvider
	) {}

	getStripeUserKey(): Observable<any> {
		const url = '/public/rest/stripe/pk';
		const headers = new HttpHeaders().set(
			'Content-Type',
			'application/x-www-form-urlencoded'
		);
		return this.http.get(url, { headers });
	}

	unsubscribeStripe(data): Observable<any> {
		const url = '/protected_base/rest/stripe/unsubscribe';
		const headers = new HttpHeaders().set(
			'Content-Type',
			'application/x-www-form-urlencoded'
		);
		const body = this.stringModifierService.urlEncodDataTransform({
			subscription: data
		});
		return this.http.post(url, body, { headers });
	}

	updateCardDetails(stripe_token: string): Observable<any> {
		const url = '/api/user/stripe/card/update';
		const headers = new HttpHeaders().set(
			'Content-Type',
			'application/x-www-form-urlencoded'
		);
		const body = this.stringModifierService.urlEncodDataTransform({
			stripe_token
		});
		return this.http.post(url, body, { headers });
	}

	subscribeStripe(stripeToken: string, subscription: string): Observable<any> {
		const url = '/api/basic/user/subscribe';
		const dataToSend = new FormData();

		dataToSend.append('stripe_token', stripeToken);
		dataToSend.append('subscription', subscription);

		return this.http.post(url, dataToSend);
	}

	updateStripe(stripeToken): Observable<any> {
		const url = '/api/user/stripe/card/update';

		const dataToSend = new FormData();
		dataToSend.append('stripe_token', stripeToken);

		return this.http.post(url, dataToSend);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/services/subscription/stripe.data.service.ts